<template>
  <div class="card-body">
    <div class="brand-wrapper">
      <img src="@/assets/images/logo.svg"
        alt="logo"
        class="logo">
    </div>
    <p class="login-card-description">Aanmelden</p>
    <div class="quicklinks">
      <router-link
        :to="{name: 'zebra'}"
        class="quicklinks__item">
        <div class="quicklinks__image">
         <img src="@/assets/images/scanner.svg">
        </div>
      </router-link>
      <router-link
      :to="{name: '365'}"
      class="quicklinks__item">
        <div class="quicklinks__image">
          <img src="@/assets/images/office365.png">
        </div>
      </router-link>
      <router-link
        :to="{name: 'qr'}"
        class="quicklinks__item">
        <div class="quicklinks__image">
          <img src="@/assets/images/qr.png">
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'login',
};
</script>

<style lang="scss">
.quicklinks, .quicklinks__item {
      width: 100%;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
}
.quicklinks__item {
      margin-bottom: 1rem;
    display: flex;
    color: #010a01;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    border-radius: .5rem;
    width: 100%;
    -webkit-box-shadow: 0 2px 5px rgba(87,102,129,.4);
    box-shadow: 0 2px 5px rgba(87,102,129,.4);
    padding: 1em 0 1em 0;
    font-weight: 700;
    text-decoration: none;
    background: white;
}
.quicklinks__image {
    width: 4em;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.quicklinks__image img {
    height: 100%;
    width: 100%;
    max-width: 4em;
    max-height: 4em;
}
</style>
